import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostCovertNarcissistDE() {
  const articleData = {
    title: 'Ist Ihr Ex ein verdeckter Narzisst? (Die Texte lügen nicht)',
    description: 'Fragen Sie sich, ob Ihr Ex ein verdeckter Narzisst ist? Entdecken Sie 7 subtile manipulative Verhaltensweisen, die unsere KI sofort in Textnachrichten erkennt.',
    slug: 'is-your-ex-a-covert-narcissist',
    publishDate: '2025-03-08',
    author: 'Toxic Detector Redaktion'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'Was ist ein verdeckter Narzisst und wie unterscheidet er sich von offenen Narzissten?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Verdeckte Narzissten verstecken ihre manipulativen Verhaltensweisen hinter Charme, subtilen emotionalen Taktiken und passiv-aggressiven Nachrichten, im Gegensatz zu offensichtlichen Narzissten.'
      }
    }, {
      '@type': 'Question',
      name: 'Kann KI verdeckten Narzisstmus in Textnachrichten erkennen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ja. Toxic Detector analysiert Tonfall, Schuldgefühle, Love-Bombing-Zyklen, Inkonsistenz und emotionale Manipulationsmuster, um verdecktes narzisstisches Verhalten zu markieren.'
      }
    }, {
      '@type': 'Question',
      name: 'Was sind häufige Verhaltensweisen verdeckter Narzissten in Texten?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Emotionale Manipulation, Gaslighting, passiv-aggressive Kommentare, das Opfer spielen, Love-Bombing gefolgt von Rückzug und subtile Kontrolle.'
      }
    }, {
      '@type': 'Question',
      name: 'Wie kann ich mich vor einem verdeckten Narzissten schützen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Dokumentieren Sie Nachrichten, vertrauen Sie Ihrem Instinkt, setzen Sie Grenzen und nutzen Sie Tools wie Toxic Detector, um manipulative Muster objektiv zu identifizieren.'
      }
    }, {
      '@type': 'Question',
      name: 'Wie genau ist Toxic Detector beim Erkennen von verdecktem Narzissmus?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Sehr genau. Die KI analysiert sprachliche Muster, Tonfall, emotionalen Druck und subtile Hinweise über mehrere Chats hinweg, um sofortige, zuverlässige Erkenntnisse zu liefern.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eAKNBAYBhED67QeywsaDY6/1763120946474.jpg',
    datePublished: articleData.publishDate,
    author: {
      '@type': 'Organization',
      name: articleData.author
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector',
      logo: {
        '@type': 'ImageObject',
        url: 'https://toxicdetector.com/images/logo.png'
      }
    }
  };
  const alternateUrls = ['https://toxicdetector.com/de/blog/is-your-ex-a-covert-narcissist', 'https://toxicdetector.com/de/blog/is-your-ex-a-covert-narcissist'];
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText('https://toxicdetector.com/');
      alert('Link in die Zwischenablage kopiert!');
    }
  };
  return <>
      <MetaTags title="Ist Ihr Ex ein verdeckter Narzisst? Wie KI verborgene Manipulation erkennt | ToxicDetector" description="Fragen Sie sich, ob Ihr Ex ein verdeckter Narzisst ist? Entdecken Sie 7 subtile manipulative Verhaltensweisen, die unsere KI sofort in Textnachrichten erkennt." keywords="verdeckter Narzisst Anzeichen, verborgenes narzisstisches Verhalten, Narzisst Manipulation Texte, KI Narzissmus Detektor, emotionale Manipulation in Beziehungen" canonical={`https://toxicdetector.com/de/blog/${articleData.slug}`} language="de" alternateUrls={alternateUrls} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/eYBGg4SniMpbkGoP3a2Uyt/file_00000000bb6072439a9d5e3820051ce3.png" schema={[faqSchema, articleSchema]} data-id="element-4073" data-mp="3oarj4biqqbxc" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-4074" data-mp="3sxadsypnptfr">
        <header className="bg-white/90 border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm" data-id="element-4075" data-mp="23ic7wzwtbm7a">
          <div className="max-w-3xl mx-auto px-6 py-4" data-id="element-4076" data-mp="1yjj6i5usvlnh">
            <div className="flex items-center justify-between" data-id="element-4077" data-mp="e072xi6efwre">
              <Link to="/" className="text-2xl font-bold tracking-tight text-gray-900" data-id="element-4078" data-mp="e0yv0j0sfccx">
                🚩 ToxicDetector
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-50 rounded-lg transition-colors" aria-label="Artikel teilen" data-id="element-4079" data-mp="49ugfkf0xtim">
                <Share2 size={20} className="text-gray-600" data-id="element-4080" data-mp="3rdii8ul1a72q" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-3xl mx-auto w-full px-6 py-12" data-id="element-4081" data-mp="3hgvw82gz19z4">
          <Link to="/blog" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors group" data-id="element-4082" data-mp="3higua22hvb1q">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-4083" data-mp="1fqkgelsutp3s" />
            Zurück zum Blog
          </Link>

          <header className="mb-12" data-id="element-4084" data-mp="1j7zvqplo7i1n">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight text-gray-900" data-id="element-4085" data-mp="1j91frjknzevi">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-4086" data-mp="198r2jyymq7gc">
              <time dateTime={articleData.publishDate} data-id="element-4087" data-mp="14a7glyk1cvnz">
                {new Date(articleData.publishDate).toLocaleDateString('de-DE', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-4088" data-mp="1x0y37abe10lk">•</span>
              <span data-id="element-4089" data-mp="1s73c3ltgdjcg">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-12" data-id="element-4090" data-mp="1n9lf8tspmukt">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eAKNBAYBhED67QeywsaDY6/1763120946474.jpg" alt="Frau analysiert Textnachrichten auf Anzeichen von verdeckter narzisstischer Manipulation mit KI" className="w-full rounded-2xl shadow-sm border border-gray-200" data-id="element-4091" data-mp="1n8inykrh6q4d" />
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200 mb-12" data-id="element-4092" data-mp="2s7oyiigh935o">
            <h2 className="font-bold text-lg mb-4 text-gray-900" data-id="element-4093" data-mp="2s9ry9u7fmanl">
              Inhaltsverzeichnis
            </h2>
            <ul className="space-y-3 text-sm" data-id="element-4094" data-mp="325v0t1674bb2">
              <li data-id="element-4095" data-mp="327pm4gldq5fo">
                <a href="#emotional-manipulation" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4096" data-mp="3241qnbwdj8yb">
                  <span className="text-gray-400" data-id="element-4097" data-mp="3b50049pl08oa">→</span> 1. Emotionale
                  Manipulation in jeder Nachricht
                </a>
              </li>
              <li data-id="element-4098" data-mp="3kwvxfijufurg">
                <a href="#gaslighting" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4099" data-mp="3kvb4fxd6gjvp">
                  <span className="text-gray-400" data-id="element-4100" data-mp="3uvv816o660h3">→</span> 2. Gaslighting, das
                  sich langsam aufbaut
                </a>
              </li>
              <li data-id="element-4101" data-mp="k27cun45azj1">
                <a href="#passive-aggressive" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4102" data-mp="f1jjhusg26ln">
                  <span className="text-gray-400" data-id="element-4103" data-mp="o1y6qzoyxvrs">→</span> 3. Passiv-aggressive
                  Kommentare
                </a>
              </li>
              <li data-id="element-4104" data-mp="d6mcuhmehpk">
                <a href="#playing-victim" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4105" data-mp="cn57fzsnxcl">
                  <span className="text-gray-400" data-id="element-4106" data-mp="a2yhpqxjnev3">→</span> 4. Ständig das Opfer
                  spielen
                </a>
              </li>
              <li data-id="element-4107" data-mp="3dra0rrp297vx">
                <a href="#love-bombing" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4108" data-mp="3dqrtm00v1998">
                  <span className="text-gray-400" data-id="element-4109" data-mp="1oa63q5kd9otj">→</span> 5. Love-Bombing dann
                  Rückzug
                </a>
              </li>
              <li data-id="element-4110" data-mp="1t1o3wrekfldg">
                <a href="#hidden-control" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4111" data-mp="1t25x1f5xljh5">
                  <span className="text-gray-400" data-id="element-4112" data-mp="1k9cftc6xca0n">→</span> 6. Versteckte
                  Kontrolle & Überwachung
                </a>
              </li>
              <li data-id="element-4113" data-mp="2bzqpew7wn06i">
                <a href="#inconsistent-tone" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4114" data-mp="2c00e8gh7r1am">
                  <span className="text-gray-400" data-id="element-4115" data-mp="22ysju9htiklt">→</span> 7. Inkonsistenter Ton
                  zwischen Kanälen
                </a>
              </li>
            </ul>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-4116" data-mp="rjvrapmfdd9p">
            <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-4117" data-mp="rlgkobx06q5z">
              Hattest du jemals das Gefühl, dass dein Ex dich hinter den
              Kulissen manipuliert hat, während er charmant und fürsorglich
              wirkte? Das sind klassische{' '}
              <strong data-id="element-4118" data-mp="2wj5k2l4pvztl">Anzeichen eines verdeckten Narzissten</strong>. Im
              Gegensatz zu offensichtlichen Narzissten verstecken verdeckte ihre
              Manipulation hinter subtilen, emotionalen Taktiken.
            </p>
            <p className="mb-12 text-lg leading-relaxed text-gray-600" data-id="element-4119" data-mp="2nge9enjo1830">
              Unsere <strong data-id="element-4120" data-mp="2rklxciiauk06">KI erkennt versteckte Manipulation</strong> sofort
              durch die Analyse ihrer Texte. Hier ist wie.
            </p>

            <section id="emotional-manipulation" className="mb-12" data-id="element-4121" data-mp="2dm4eoz793xp4">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4122" data-mp="2ijecp38phhok">
                1️⃣ Emotionale Manipulation in jeder Nachricht
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-4123" data-mp="grriytxfj8oe">
                Verdeckte Narzissten verdrehen Emotionen, um ihren Willen
                durchzusetzen.
              </p>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4124" data-mp="1waz59pd3lyt7">
                <p className="italic text-gray-700 text-lg" data-id="element-4125" data-mp="2azvcxlb8t9ta">
                  "Ich kann nicht glauben, dass du dich darüber aufregst..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-4126" data-mp="2k01lqtvzxlm4">
                Die KI erkennt subtile Schuldgefühle und emotionalen Druck, der
                in alltäglichen Nachrichten versteckt ist.
              </p>
            </section>

            <section id="gaslighting" className="mb-12" data-id="element-4127" data-mp="2tx67islxjf2e">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4128" data-mp="2oz4pmb08plsi">
                2️⃣ Gaslighting, das sich langsam aufbaut
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4129" data-mp="zkggqjquylz8">
                <p className="italic text-gray-700 text-lg" data-id="element-4130" data-mp="umoeavsl7hgs">
                  "Das hast du falsch in Erinnerung..."
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-4131" data-mp="1oaayikibvqyo">
                Verdeckte Narzissten lassen dich an deinem eigenen Gedächtnis
                zweifeln. Die KI markiert wiederholte Fälle, in denen die
                Realität verdreht wird.
              </p>
            </section>

            <section id="passive-aggressive" className="mb-12" data-id="element-4132" data-mp="238mu0ntysto9">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4133" data-mp="236afkknf11fy">
                3️⃣ Passiv-aggressive Kommentare
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4134" data-mp="2c1ghv9nh91dq">
                <p className="italic text-gray-700 text-lg" data-id="element-4135" data-mp="2gygmrh8lby39">
                  "Sicher, was auch immer dich glücklich macht..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-4136" data-mp="2qxfvt0x9pvqs">
                Passive Aggression ist ein Kennzeichen von verdecktem
                Narzissmus. Die KI erkennt Sarkasmus, hinterhältige Sticheleien
                und maskierte Feindseligkeit.
              </p>
            </section>

            <section id="playing-victim" className="mb-12" data-id="element-4137" data-mp="5bwjpfib3fmb">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4138" data-mp="5ceo4zf4h05b">
                4️⃣ Ständig das Opfer spielen
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4139" data-mp="y1ddaghnx2k4">
                <p className="italic text-gray-700 text-lg" data-id="element-4140" data-mp="t17g6ksminun">
                  "Nach allem, was ich für dich getan habe..."
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-4141" data-mp="o8xvbj6d8dz8">
                Verdeckte Narzissten drehen oft die Schuld um und machen sich
                selbst zum Opfer. Die KI erkennt Phrasen, die darauf ausgelegt
                sind, Schuldgefühle zu erzeugen.
              </p>
            </section>

            <section id="love-bombing" className="mb-12" data-id="element-4142" data-mp="wili3jvw5wr5">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4143" data-mp="wh0n5t5o0bsr">
                5️⃣ Love-Bombing dann Rückzug
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4144" data-mp="mknu8xhy21z2">
                <p className="italic text-gray-700 text-lg" data-id="element-4145" data-mp="rj8rqp5ta7jt">
                  "Du bist die Einzige, die ich je geliebt habe 😢" → Ghosting
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-4146" data-mp="1fbfkzfg8pyf0">
                Dieser klassische Zyklus von intensiver Zuneigung gefolgt von
                emotionaler Distanz ist ein Warnsignal. Die KI identifiziert
                diese Muster über mehrere Chats hinweg.
              </p>
            </section>

            <section id="hidden-control" className="mb-12" data-id="element-4147" data-mp="1y879q4ejx5qg">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4148" data-mp="1y6mh4kbsrwv8">
                6️⃣ Versteckte Kontrolle & Überwachung
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4149" data-mp="3noaxwmpm5jqu">
                <p className="italic text-gray-700 text-lg" data-id="element-4150" data-mp="3iqrmdukavl2l">
                  "Ich wollte nur mal nachfragen... schon wieder"
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-4151" data-mp="1bb58w52d7tj">
                Subtile Kontrolle, die als Fürsorge getarnt ist, ist eine
                verdeckte Taktik. Die KI markiert wiederholtes Kontrollieren
                ohne offene Aggression.
              </p>
            </section>

            <section id="inconsistent-tone" className="mb-12" data-id="element-4152" data-mp="3dqww9t8cmzil">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4153" data-mp="3dsg897mz2oek">
                7️⃣ Inkonsistenter Ton zwischen Kanälen
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4154" data-mp="t04nt0ixux6a">
                <p className="italic text-gray-700 text-lg" data-id="element-4155" data-mp="ozlybd4iq379">
                  Gruppenchat: verspielt / 1:1: kritisch
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-4156" data-mp="3hvnh21bi7szp">
                Verdeckte Narzissten maskieren ihr Verhalten oft öffentlich,
                während sie privat manipulieren. Die KI vergleicht Gespräche, um
                Diskrepanzen aufzuzeigen.
              </p>
            </section>

            <section className="mb-12" data-id="element-4157" data-mp="3vqzmp3r773ve">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4158" data-mp="2z3uo26wfq7rz">
                🛡 Wie Sie sich schützen können
              </h2>
              <div className="bg-white rounded-xl border border-gray-200 p-6" data-id="element-4159" data-mp="3401x48k4nze5">
                <ul className="space-y-3 text-lg text-gray-600" data-id="element-4160" data-mp="3826ot1r0mly5">
                  <li className="flex items-start gap-3" data-id="element-4161" data-mp="3cupxplercswm">
                    <span className="text-purple-600 font-bold" data-id="element-4162" data-mp="3cwavrl0a6tz8">•</span>
                    <span data-id="element-4163" data-mp="2gc23n0vfluvv">
                      Vertrauen Sie Ihrem Instinkt. Ignorieren Sie keine
                      Warnsignale.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4164" data-mp="2ctcsyfn5d7v2">
                    <span className="text-purple-600 font-bold" data-id="element-4165" data-mp="27vt3ejl018nt">•</span>
                    <span data-id="element-4166" data-mp="27tgm88n2f2bt">Bewahren Sie Screenshots zur Klarheit auf.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4167" data-mp="23w2hat6f3gpm">
                    <span className="text-purple-600 font-bold" data-id="element-4168" data-mp="1yttllp25u0jt">•</span>
                    <span data-id="element-4169" data-mp="1tvicxhnlpw36">
                      Teilen Sie Ihre Erfahrungen mit Freunden oder einem
                      Therapeuten.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4170" data-mp="1k5yrq5cf1q55">
                    <span className="text-purple-600 font-bold" data-id="element-4171" data-mp="1k6i99ky5mcin">•</span>
                    <span data-id="element-4172" data-mp="1g56i3azmtj8c">
                      Nutzen Sie Tools wie Toxic Detector, um Muster zu
                      identifizieren.
                    </span>
                  </li>
                </ul>
              </div>
            </section>

            <section className="mb-12" data-id="element-4173" data-mp="168ahrsjw03ev">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4174" data-mp="2u2drjfo9rrav">
                💀 Sehen Sie es mit eigenen Augen
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-4175" data-mp="2z171wz89f26t">
                Verdeckter Narzissmus kann schwer zu erkennen sein, aber KI
                übersieht nichts. Laden Sie Ihre Chats hoch und erhalten Sie
                eine sofortige Analyse:
              </p>
              <div className="bg-white border border-gray-200 rounded-xl p-6 mb-6" data-id="element-4176" data-mp="2baupbb22kh9w">
                <p className="text-gray-900 font-bold text-center text-lg" data-id="element-4177" data-mp="2g3w65olu6qw4">
                  "🚩 78% Manipulation erkannt. Verdeckte Taktiken
                  identifiziert!"
                </p>
              </div>
            </section>

            <section id="faq" className="mb-12" data-id="element-4178" data-mp="26b870n7dwau8">
              <h2 className="text-3xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-4179" data-mp="1sel13uxgeac6">
                Häufig gestellte Fragen
              </h2>
              <div className="space-y-4" data-id="element-4180" data-mp="1xephzm29x72x">
                {faqSchema.mainEntity.map((faq, index) => <details key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden group" data-id="element-4181" data-mp="1dso0bcs3ib0a" data-mpi={index}>
                    <summary className="px-6 py-4 cursor-pointer font-semibold text-base text-gray-900 hover:bg-gray-50 transition-colors flex items-center justify-between" data-id="element-4182" data-mp="1nqlk9o2x9ln3">
                      <span data-id="element-4183" data-mp="1wonki1eu0a9b">{faq.name}</span>
                      <ChevronDown size={20} className="text-gray-400 group-open:rotate-180 transition-transform" data-id="element-4184" data-mp="1wncfjy9ngwgm" />
                    </summary>
                    <div className="px-6 pb-4 text-gray-600 leading-relaxed text-sm" data-id="element-4185" data-mp="21gf9i7ica7xc">
                      {faq.acceptedAnswer.text}
                    </div>
                  </details>)}
              </div>
            </section>
          </div>

          <div className="bg-purple-600 rounded-2xl p-10 text-center text-white mt-16" data-id="element-4186" data-mp="2bg64eaataoxy">
            <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-4187" data-mp="2nw0e1c21y91m">
              💀 Bereit, die Wahrheit aufzudecken?
            </h2>
            <p className="text-purple-100 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-4188" data-mp="2j0kxgccntz1i">
              Hören Sie auf zu raten. Laden Sie Ihre Texte bei Toxic Detector
              hoch und erhalten Sie einen sofortigen Toxizitäts-Score. Unsere KI
              enthüllt verdeckte Manipulation, die Sie vielleicht übersehen
              haben.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/20" data-id="element-4189" data-mp="20920am5bhf7e">
              <p className="font-bold text-xl" data-id="element-4190" data-mp="2e0q8wfgcxljm">
                "🚩 78% Manipulation erkannt. Verdeckte Taktiken identifiziert!"
              </p>
            </div>
            <Link to="/signup" className="inline-block bg-white text-purple-600 px-10 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors" data-id="element-4191" data-mp="1licmrd4dvo0d">
              Scannen Sie Ihre Chats jetzt →
            </Link>
          </div>

          <RelatedBlogPosts posts={[{
          title: '7 Anzeichen von Gaslighting, die unsere KI sofort erkennt',
          description: 'Lerne die wichtigsten Gaslighting-Muster, die KI in deinen Textgesprächen erkennt.',
          slug: '7-signs-of-gaslighting',
          emoji: '💀'
        }, {
          title: 'Der ultimative Guide zu passiv-aggressiven Texten',
          description: 'Erkenne passiv-aggressives Verhalten und versteckte Manipulation in Textnachrichten.',
          slug: 'passive-aggressive-texts-guide',
          emoji: '😤'
        }]} data-id="element-4192" data-mp="sfiihcw26bw" />

          <div className="mt-12 text-center" data-id="element-4193" data-mp="2qgzl8aqf26vk">
            <button onClick={handleShare} className="inline-flex items-center text-gray-600 hover:text-gray-900 font-medium transition-colors text-sm" data-id="element-4194" data-mp="2vgug0pdbbglw">
              <Share2 size={18} className="mr-2" data-id="element-4195" data-mp="27d4jywbmn5e4" />
              Diesen Artikel teilen
            </button>
          </div>
        </article>

        <footer className="bg-white border-t border-gray-200 py-12 mt-16" data-id="element-4196" data-mp="22le64gdhdzhy">
          <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-4197" data-mp="1xnusniolxqr2">
            <p className="text-gray-500 text-sm" data-id="element-4198" data-mp="1xl8kphxt198b">
              © {new Date().getFullYear()} ToxicDetector. Alle Rechte
              vorbehalten.
            </p>
          </div>
        </footer>
      </div>
    </>;
}